export function getIsNewUserFromLC() {
    const isNewUser = localStorage.getItem("IS_NEW_USER");
    const value = isNewUser ? JSON.parse(isNewUser) : false;
    return value;
  }